import logo from "./marketing-logo.png";
import "./marketing.css";

export { logo as marketingLogo };

export function MarketingBrand({ compact = false, tagline = false }: { compact?: boolean; tagline?: boolean }): React.JSX.Element {
  return <span className={`brand marketing-brand ${compact ? "brand--compact" : ""}`}>
    <img className="brand-symbol" src={logo} width="664" height="797" alt="" />
    <span className="brand-type"><strong>FIVE CROWN</strong><span className="brand-system">SYSTEM</span>{tagline && <small>POWERING BINGO. EVERYWHERE.</small>}</span>
  </span>;
}

export function MarketingHeader({ enter }: { enter: (area: "public" | "company") => void }): React.JSX.Element {
  return <header className="product-header marketing-header">
    <button className="wordmark" aria-label="Five Crown System" onClick={() => enter("public")}><MarketingBrand compact /></button>
    <nav aria-label="Main navigation"><button className="marketing-sign-in" onClick={() => enter("company")}>Customer sign in</button></nav>
  </header>;
}
